/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

//these properties not being defined will be considered the same as them being false

// export interface SimpleAttribute {
// 	localOnly?: boolean; //don't copy from the database source to the primary view
// 	noWrite?: boolean; //strip out the data when generating the database writable object
// 	ignoreLocal?: boolean; //don't copy the data when switching between modes. Set when you want special handling.
// }

//TODO - enhance the default copy method, or allow copy to be a custom function with instructions for how to copy it
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface SimpleAttribute {
	/**
	 * true - the value gets read out of firebase and will overwrite the local value (a null value will overwrite a local value with null).
	 * false - the value will not be read from firebase at all, this is useful for local only attributes
	 */
	read: boolean;
	/** true - is written to firebase when persisting, false - is not written to firebase when persisting */
	write: boolean;
	/** true - value will be copied when switching views, false - value will not be copied */
	copy: boolean;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface SimpleAttributeList {
	/** wildcard specification, defines the behavior for any attributes that are otherwise unspecified */
	// '*'?: SimpleAttribute; //do not remove, this is for doc
	[key: string]: SimpleAttribute;
}

export const wildCardAttribute: string = '*';

/** completely standard behavior, read it, write it, copy it */
// eslint-disable-next-line @rushstack/typedef-var
export const defaultAttribute = { read: true, write: true, copy: true } as const;
/** likely fbdb generated, just read it */
// eslint-disable-next-line @rushstack/typedef-var
export const readOnlyAttribute = { read: true, write: false, copy: true } as const;
/** local only, simple enough to be copied between views */
// eslint-disable-next-line @rushstack/typedef-var
export const simpleLocalAttribute = { read: false, write: false, copy: true } as const;
/** local only, do not copy between views */
// eslint-disable-next-line @rushstack/typedef-var
export const recalcRequiredLocalAttribute = { read: false, write: false, copy: false } as const;

/**
 * Used to generate a default attribute list. Mainly for simple objects, or as a placeholder when setting things up.
 * @param  arr An array of keys to use to generate the default simple attribute list
 */
export function generateSimplestList(arr?: string[]): SimpleAttributeList {
	if (!arr) {
		return {};
	}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const obj: any = {};
	arr.forEach((key) => {
		obj[key] = defaultAttribute;
	});
	return obj;
}
